export const OPEN_ERROR_INFO_MODAL = 'ERROR/OPEN_ERROR_INFO_MODAL';
export const CLOSE_ERROR_INFO_MODAL = 'ERROR/CLOSE_ERROR_INFO_MODAL';

export const UPDATE_VALIDATION_ERRORS = 'ERROR/UPDATE_VALIDATION_ERRORS';

export const SEND_ERROR_TO_BUGSNAG = 'ERROR/SEND_ERROR_TO_BUGSNAG';

export const CALL_ERROR_HANDLER = 'ERROR/CALL_ERROR_HANDLER';
